const routes = [
    {
        path: "/tuition/calculator",
        component: () => import("../pages/PublicCalculator.vue"),
    },
    {
        path: "/tuition",
        component: () => import("../pages/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: "calculatorfee_index"
        }
    },

];

export default routes;
